<script setup>
/**
 * UserMultiSelect — searchable chip-based multi-select over a user list.
 * v-model is an array of user ids.
 * users: [{ id, name, display_name, customer_id, company, department, image }]
 */
const props = defineProps({
  modelValue: { type: Array, default: () => [] },
  users:       { type: Array, default: () => [] },
  label:       { type: String, default: "Recipients" },
  loading:     { type: Boolean, default: false },
});
const emit = defineEmits(["update:modelValue"]);

const items = computed(() =>
  props.users.map((u) => ({
    value: u.id,
    title: u.name || u.display_name || u.customer_id || u.id,
    subtitle: [u.company, u.department, u.customer_id].filter(Boolean).join(" · "),
  }))
);
</script>

<template>
  <VAutocomplete
    :model-value="modelValue"
    :items="items"
    :label="label"
    :loading="loading"
    item-title="title"
    item-value="value"
    multiple
    chips
    closable-chips
    clearable
    :no-data-text="loading ? 'Loading users…' : 'No users found'"
    @update:model-value="emit('update:modelValue', $event)"
  >
    <template #item="{ item, props: itemProps }">
      <VListItem v-bind="itemProps" :subtitle="item.raw.subtitle" />
    </template>
  </VAutocomplete>
</template>
